module.exports = __webpack_public_path__ + "static/media/horse-group.32e38c8f.png";